import React from 'react';

const StructuredData = ({ type, data }) => {
  const getStructuredData = () => {
    switch (type) {
      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "San Diego Gaming",
          "alternateName": "SD Gaming",
          "url": "https://sandiegogaming.com",
          "logo": "https://sandiegogaming.com/logo.png",
          "description": "San Diego's premier gaming community featuring esports tournaments, gaming events, and clubs for competitive gamers.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "San Diego",
            "addressRegion": "CA",
            "addressCountry": "US"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "url": "https://sandiegogaming.com/contact"
          },
          "sameAs": [
            "https://twitter.com/sandiegogaming",
            "https://facebook.com/sandiegogaming",
            "https://instagram.com/sandiegogaming"
          ],
          "foundingDate": "2024",
          "slogan": "San Diego's Premier Gaming Community"
        };

      case 'event':
        return {
          "@context": "https://schema.org",
          "@type": "Event",
          "name": data.name || "Gaming Tournament",
          "description": data.description || "Competitive gaming tournament in San Diego",
          "startDate": data.startDate || new Date().toISOString(),
          "endDate": data.endDate || new Date().toISOString(),
          "location": {
            "@type": "Place",
            "name": data.location || "San Diego, CA",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "San Diego",
              "addressRegion": "CA",
              "addressCountry": "US"
            }
          },
          "organizer": {
            "@type": "Organization",
            "name": "San Diego Gaming",
            "url": "https://sandiegogaming.com"
          },
          "eventStatus": "https://schema.org/EventScheduled",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "offers": {
            "@type": "Offer",
            "price": data.price || "0",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
          }
        };

      case 'website':
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "San Diego Gaming",
          "url": "https://sandiegogaming.com",
          "description": "San Diego's premier gaming community featuring esports tournaments, gaming events, and clubs.",
          "publisher": {
            "@type": "Organization",
            "name": "San Diego Gaming",
            "logo": {
              "@type": "ImageObject",
              "url": "https://sandiegogaming.com/logo.png"
            }
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://sandiegogaming.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        };

      case 'breadcrumb':
        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": data.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.url
          }))
        };

      default:
        return null;
    }
  };

  const structuredData = getStructuredData();

  if (!structuredData) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default StructuredData;

